import {
  Bot,
  BookOpenCheck,
  Building2,
  CircleDot,
  ClipboardList,
  FileText,
  FolderKanban,
  Globe,
  Inbox,
  LayoutDashboard,
  List,
  PhoneCall,
  NotebookPen,
  MessageSquareText,
  Receipt,
  RefreshCw,
  Sparkles,
  ToggleRight,
  Users,
  WalletCards,
  type LucideIcon,
} from 'lucide-react';

/**
 * Curated lucide icon map for the Client Portal. Module configs reference
 * icons by string key so the registry stays serializable and free of JSX.
 */
const ICONS: Record<string, LucideIcon> = {
  LayoutDashboard,
  Building2,
  Bot,
  BookOpenCheck,
  PhoneCall,
  NotebookPen,
  Receipt,
  RefreshCw,
  Sparkles,
  ToggleRight,
  Globe,
  ClipboardList,
  FileText,
  FolderKanban,
  Inbox,
  List,
  MessageSquareText,
  Users,
  WalletCards,
};

export function resolveIcon(name?: string): LucideIcon {
  if (name && ICONS[name]) return ICONS[name] as LucideIcon;
  return CircleDot;
}
